module.exports = __webpack_public_path__ + "img/temperature.366eba9e.svg";